export default "__VITE_ASSET__$VoQ75Zw__"